export default __webpack_public_path__ + "static/pragicts-our-perspectives-banner-reflect-a07cfbca1622f5cc5d6386a05865e27d.jpg";